<script lang="ts">
    export let small: number = 12;
    export let medium: number = null;
    export let large: number = null;
    export let extra_large: number = null;
</script>

<div
    class="col
        {small ? "s"+small : ""}
        {medium ? "m"+medium : ""}
        {large ? "l"+large : ""}
        {extra_large ? "xl"+extra_large : ""}
        ">
    <slot></slot>
</div>